/* PRELUDIO v7/v8 - scheda prodotto (titolo e 'Nuova stagione' ora dal CSS in testa) */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var path = location.pathname.replace(/[/]$/, '');
  function pul(u) { try { return new URL(u, location.origin).pathname.replace(/[/]$/, ''); } catch (e) { return ''; } }
  function blocco(el) { return el && (el.closest('.product-info__block-item') || el); }
  function prezzo() { var s = document.querySelector('.product-info sale-price'); if (!s) return ''; var c = s.cloneNode(true); c.querySelectorAll('.sr-only').forEach(function (x) { x.remove(); }); return c.textContent.trim(); }
  function taglia() { var b = document.querySelector('.product-info variant-picker button.select, .product-info variant-picker .select'); var t = b ? b.textContent.trim() : ''; return /seleziona/i.test(t) ? '' : t; }
  function sku() {
    var it = null, det = null;
    document.querySelectorAll('.product-info__block-item').forEach(function (x) { if (/^SKU:/i.test(x.textContent.trim())) it = x; });
    document.querySelectorAll('.product-info .accordion__toggle').forEach(function (t) { if (t.textContent.trim().toUpperCase() === 'DETTAGLI') det = t.closest('details') || t.parentNode; });
    if (!it || !det) return;
    it.style.display = 'none';
    var c = det.querySelector('.accordion__content') || det;
    var p = c.querySelector('.pl-sku');
    if (!p) { p = document.createElement('p'); p.className = 'pl-sku'; p.style.cssText = 'margin:8px 0 0;font-size:12px;color:#666'; c.appendChild(p); }
    p.textContent = it.textContent.trim();
  }
  function barra() {
    if (innerWidth > 749) return;
    var bar = document.querySelector('product-sticky-bar'); if (!bar) return;
    var btn = bar.querySelector('button[type="submit"], button.button, .button'); if (!btn) return;
    var el = bar.querySelector('.pl-sticky-prezzo');
    if (!el) { el = document.createElement('div'); el.className = 'pl-sticky-prezzo'; btn.parentNode.classList.add('pl-sticky-riga'); btn.parentNode.insertBefore(el, btn); }
    var t = taglia(); el.innerHTML = prezzo() + (t ? '<small>Taglia ' + t + '</small>' : '');
  }
  function stagione() {
    if (document.querySelector('.pl-nuova-stagione')) return;
    var h = path.split('/products/')[1]; if (!h) return;
    fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var tags = p.tags || [];
      if (tags.indexOf('STAGIONE_226') === -1 || document.querySelector('.pl-nuova-stagione')) return;
      if (document.body.innerText.indexOf('Nuova stagione') !== -1 && document.querySelector('.product-info') && document.querySelector('.product-info').innerText.indexOf('Nuova stagione') !== -1) return;
      var v = document.querySelector('.product-info a.vendor, .product-info .vendor'); if (!v) return;
      var t = document.createElement('p'); t.className = 'pl-nuova-stagione'; t.textContent = 'Nuova stagione';
      t.style.cssText = 'margin:0 0 2px;font-size:12px;color:#666;letter-spacing:0;text-transform:none';
      var b = blocco(v); b.parentNode.insertBefore(t, b);
    }).catch(function () {});
  }
  function sistema() {
    document.body.classList.add('pl-pdp');
    var lista = document.querySelector('.preludio-servizi');
    if (lista) lista.querySelectorAll('li').forEach(function (li) { if (/trustpilot/i.test(li.textContent)) li.innerHTML = '<strong>Recensioni</strong> <a href="https://it.trustpilot.com/review/preludiomoda.it" target="_blank" rel="noopener" style="color:inherit">su Trustpilot</a>'; });
    var v = document.querySelector('.varianti-atelier-container');
    if (v && !v.dataset.pl) {
      v.dataset.pl = '1';
      var altre = [].filter.call(v.querySelectorAll('a'), function (a) { return pul(a.href) !== path; });
      var bv = blocco(v);
      if (!altre.length) bv.style.display = 'none';
      else if (lista) { var bl = blocco(lista); bl.parentNode.insertBefore(bv, bl.nextSibling); }
    }
    sku(); barra();
  }
  function avvia() { setTimeout(sistema, 400); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia); else avvia();
  var agg = function () { setTimeout(function () { sku(); barra(); }, 80); };
  document.addEventListener('variant:change', agg);
  document.addEventListener('change', agg);
})();